import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
const TopicPage = dynamic(() => import("@/screens/Topic"));
// import PageLayout from "@/screens/Layout/PageLayout";
// import TopicPage from "@/screens/Topic";

const Index = ({
  topicListData = null,
  allTopicsData = null,
  latestStoryData = null,
  latestVideoData = null,
}) => {
  const isMobileDevice = useIsMobile();
  return (
    <PageLayout
      latestVideoData={latestVideoData}
      latestStoryData={latestStoryData}
      isMobileDevice={isMobileDevice}
    >
      <TopicPage
        topicListData={topicListData}
        allTopicsData={allTopicsData}
        isMobileDevice={isMobileDevice}
      />
    </PageLayout>
  );
};

export default Index;

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];
    const { getTopicList } = await import("@/handlers/topic");
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { generateAllTopics } = await import("@/utils/topicList");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let topicListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "topiclisting_", page: page, display: 50 },
    });
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let [topicListData, { latestStoryData, latestVideoData }] = await Promise.all([
      fetchRedisWrapper(topicListRedisKey, () =>
        getTopicList({ page: page, display: 50 })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
    ]);

    let headerCache = topicListData?.headerCache;
    setPageTTL(ctx, headerCache?.akamai_ttl);

    let allTopicsData = generateAllTopics(topicListData?.content) ?? [];

    return {
      props: {
        topicListData,
        allTopicsData,
        latestStoryData,
        latestVideoData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      props: {
        topicListData: null,
        allTopicsData: null,
      },
    };
  }
};
